import React from "react";
import RegisterForm from "./RegristerForm"; 

const Register = ({ selectedUser }) => {
  return (
    <div className="py-8">
      <div className="max-w-7xl mx-auto px-4">
        <RegisterForm selectedUser={selectedUser} />
      </div>
    </div>
  );
};


export default Register;

